const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-KLS69DD29K';

let hasInitialized = false;
let isEnabled = false;

const sanitizePath = (path) => {
  if (!path || typeof window === 'undefined') return path || '';

  try {
    const url = new URL(path, window.location.origin);
    ['session_id', 'payment_intent', 'payment_intent_client_secret'].forEach((param) => {
      url.searchParams.delete(param);
    });
    return `${url.pathname}${url.search}`;
  } catch (error) {
    return path;
  }
};

const getPagePath = () => {
  if (typeof window === 'undefined') return '';
  return sanitizePath(`${window.location.pathname}${window.location.search}`);
};

const normalizeTarget = (href) => {
  if (!href || typeof window === 'undefined') return undefined;

  try {
    const url = new URL(href, window.location.origin);
    return url.origin === window.location.origin
      ? sanitizePath(`${url.pathname}${url.search}`)
      : `${url.origin}${url.pathname}`;
  } catch (error) {
    return undefined;
  }
};

const centsToAmount = (valueInCents) => {
  const cents = Number(valueInCents);
  return Number.isFinite(cents) ? cents / 100 : undefined;
};

export const initAnalytics = () => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') return false;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!hasInitialized) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

    hasInitialized = true;
  }

  isEnabled = true;
  return true;
};

export const trackPageView = (path = getPagePath()) => {
  if (!isEnabled || !GA_MEASUREMENT_ID || typeof window.gtag !== 'function') return;

  const pagePath = sanitizePath(path);
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_title: document.title,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isEnabled || !GA_MEASUREMENT_ID || typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, params);
};

export const trackClick = (event) => {
  const target = event.target?.closest?.('a, button, [data-analytics-label]');
  if (!target) return;

  const label = (
    target.dataset.analyticsLabel ||
    target.getAttribute('aria-label') ||
    target.textContent ||
    ''
  ).trim().replace(/\s+/g, ' ').slice(0, 80);

  trackEvent('click', {
    element_type: target.tagName.toLowerCase(),
    element_label: label || undefined,
    page_path: getPagePath(),
    link_url: normalizeTarget(target.getAttribute('href')),
  });
};

export const analyticsItemFromCartItem = (item) => ({
  item_id: item?._id,
  item_name: item?.title,
  item_category: item?.category,
  item_variant: item?.variant?.variant_name,
  price: centsToAmount(item?.variant?.discount_price || item?.variant?.price),
  quantity: item?.quantity,
});

export const centsToAnalyticsAmount = centsToAmount;
